import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {},
};

const getDetailEvaluationSlice = createSlice({
  name: "getDetailEvaluation",
  initialState,
  reducers: {
    getDetailEvaluationStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailEvaluationSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDetailEvaluationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDetailEvaluation: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {};
    },
  },
});

export const {
  getDetailEvaluationStart,
  getDetailEvaluationSuccess,
  getDetailEvaluationFailed,
  resetDetailEvaluation,
} = getDetailEvaluationSlice.actions;

export default getDetailEvaluationSlice.reducer;
